/**
 * Merges the right-hand object into the left-hand object. Nested objects are merged, while
 * primitives and arrays are overwritten.
 */
export default function deepMerge(
  target: object,
  source: object,
  skipFalsy: boolean = false,
) {
  for (const key in source) {
    const sourceValue = source[key];

    if (
      sourceValue &&
      typeof sourceValue === "object" &&
      !Array.isArray(sourceValue)
    ) {
      if (!(target[key] && typeof target[key] === "object")) {
        target[key] = {};
      }

      deepMerge(target[key], sourceValue, skipFalsy);

      continue;
    }

    if (skipFalsy && !sourceValue) continue;
    target[key] = sourceValue;
  }

  return target;
}
